/**
 * Politica de entrega para pedidos con pago adelantado.
 *
 * El checkout de Shopify no se puede modificar fuera de Shopify Plus, asi que
 * interceptamos el ultimo paso que si controlamos: el boton "Finalizar compra"
 * del carrito y del drawer. Al autorizar, guardamos la aceptacion como atributo
 * del carrito para que quede constancia en el pedido, y recien ahi dejamos
 * continuar al pago.
 */
(function () {
  'use strict';

  var ACCEPTED_FLAG = 'data-policy-accepted';

  function modal() {
    return document.querySelector('[data-delivery-policy]');
  }

  /** Botones que llevan al pago y deben pasar por la autorizacion. */
  function isCheckoutTrigger(el) {
    return el.closest('[name="checkout"], button[name="checkout"]');
  }

  function open(pendingButton) {
    var el = modal();
    if (!el) return;
    el.dataset.pendingId = pendingButton.dataset.policyId;
    el.hidden = false;
    document.body.style.overflow = 'hidden';
    var accept = el.querySelector('[data-policy-accept]');
    if (accept) accept.focus();
  }

  function close() {
    var el = modal();
    if (!el) return;
    el.hidden = true;
    document.body.style.overflow = '';
    setError('');
  }

  function setError(message) {
    var el = modal();
    if (!el) return;
    var box = el.querySelector('[data-policy-error]');
    if (!box) return;
    box.textContent = message;
    box.hidden = !message;
  }

  /**
   * Guarda la aceptacion como atributo del carrito. Queda visible en el detalle
   * del pedido en el admin, que es la constancia de que el cliente autorizo.
   */
  function recordAcceptance() {
    var el = modal();
    var name = (el && el.dataset.attributeName) || 'Politica de entrega';
    var stamp = new Date().toLocaleString('es-PE', {
      dateStyle: 'short',
      timeStyle: 'short',
      timeZone: 'America/Lima'
    });
    var attributes = {};
    attributes[name] = 'Aceptada por el cliente el ' + stamp;

    return fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root + 'cart/update.js'
      : '/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attributes })
    }).then(function (res) {
      if (!res.ok) throw new Error('No se pudo registrar la autorizacion.');
      return res.json();
    });
  }

  // Cada boton de checkout recibe un id para poder reactivarlo tras autorizar.
  var seq = 0;
  function tag(button) {
    if (!button.dataset.policyId) {
      seq += 1;
      button.dataset.policyId = 'policy-' + seq;
    }
    return button.dataset.policyId;
  }

  document.addEventListener(
    'click',
    function (event) {
      var el = modal();
      if (!el || el.dataset.disabled === 'true') return;

      var button = isCheckoutTrigger(event.target);
      if (!button) return;

      // Ya autorizo en este clic: dejamos pasar el envio real.
      if (button.hasAttribute(ACCEPTED_FLAG)) return;

      event.preventDefault();
      event.stopPropagation();
      tag(button);
      open(button);
    },
    true
  );

  document.addEventListener('click', function (event) {
    var el = modal();
    if (!el || el.hidden) return;

    if (event.target.closest('[data-policy-dismiss]')) {
      close();
      return;
    }

    var accept = event.target.closest('[data-policy-accept]');
    if (!accept) return;

    accept.disabled = true;
    setError('');

    recordAcceptance()
      .then(function () {
        var id = el.dataset.pendingId;
        var button = document.querySelector('[data-policy-id="' + id + '"]');
        close();
        if (!button) return;
        // Marcamos y reenviamos: el interceptor lo deja pasar esta vez.
        button.setAttribute(ACCEPTED_FLAG, 'true');
        button.click();
      })
      .catch(function (error) {
        setError(error.message || 'Ocurrio un error. Intentalo nuevamente.');
      })
      .finally(function () {
        accept.disabled = false;
      });
  });

  document.addEventListener('keydown', function (event) {
    var el = modal();
    if (event.key === 'Escape' && el && !el.hidden) close();
  });
})();
